/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleResponsePage } from '../../models/article-response-page';

export interface ListRelatedArticles$Params {
  id: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'body' | '-body' | 'canonicalLink' | '-canonicalLink' | 'analysisState' | '-analysisState' | 'title' | '-title' | 'summary' | '-summary' | 'date' | '-date' | 'trustScore' | '-trustScore' | 'polarization' | '-polarization' | 'variations' | '-variations' | 'link' | '-link' | 'data' | '-data' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'rawContentId' | '-rawContentId'>;
}

export function listRelatedArticles(http: HttpClient, rootUrl: string, params: ListRelatedArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleResponsePage>> {
  const rb = new RequestBuilder(rootUrl, listRelatedArticles.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleResponsePage>;
    })
  );
}

listRelatedArticles.PATH = '/v0/articles/{id}/related';
